import {concat} from "../core/collections";
import {isFun} from "../core/types";
// import {Component, VText} from "./vm2/vnode";
import * as util from "./util";

export const NODETYPE = {
    TEXT: 0,
    NODE: 1,
    VIEW: 2
}

/**
 * @property {[VNode|View|String]|VNode|View|String} nodes
 * @property {View} [$view]
 * @property {HTMLElement|Element|Node} [element]
 */
export class VNode {
    constructor(tag, props, ...children) {
        this.$tag = tag;
        if (tag === '#text') {
            this.$type = NODETYPE.TEXT
            this.text = props
            this.isText = true
            return;
        }
        this.isNode = true
        this.$type = NODETYPE.NODE

        if (props) {
            concat(this, util.compileProps(props))
        }

        if (children) {
            children = util.flattenChildren(children)
            this.nodes = children
        }
    }

    /**
     * Create View | VNode | #TEXT
     *
     * @param {View|VNode|String|Number} type
     * @param {Object|undefined} props
     * @param {View|VNode|String|Number} children
     * @returns {any|VNode}
     */
    static create(type, props = {}, ...children) {
        if (props === null) props = {};

        // flatten arrays and change str/num to VNode(#text)
        children = util.flattenChildren(children)

        // View class instance
        if (type.isView) {
            return type.createInstance(props, children)
        }

        // View class
        if (type.$type === NODETYPE.VIEW) {
            return new type().updateInstance(props, children)
        }

        // create VNode instance
        return VNode.createTag(type, props, ...children);
    }

    static createText(str) {
        return new VNode('#text', str)
    }

    static createTag(type, props = {}, ...children) {
        return new VNode(type, props, ...children)
    }
}